export default "__VITE_ASSET__KLmTwoAp__"